import { Failure } from '@geekbears/gb-ngrx-stack-base';
import { createAction, props } from '@ngrx/store';
import { ApiQueryParams } from '@utils/api-query-params.type';
import {
  CreateRequest,
  EditRequest,
  GetAllRequestResponse,
  GetRequestsCountResponse,
  GetRequestToEditResponse,
  Request,
} from '../../domain';

/**
 * Actions For All Requests
 */
export const getAllRequestsAction = createAction(
  '[Requests] Get All Requests Action',
  props<{
    companyId: string;
  }>()
);
export const getAllRequestsSuccessAction = createAction(
  '[Requests] Get All Requests Success Action',
  props<{
    response: GetAllRequestResponse;
  }>()
);
export const getAllRequestsFailureAction = createAction(
  '[Requests] Get All Requests Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Create Request
 */
export const createRequestAction = createAction(
  '[Requests] Create Request Action',
  props<{
    request: CreateRequest;
  }>()
);
export const createRequestSuccessAction = createAction(
  '[Requests] Create Request Success Action',
  props<{
    requests: any;
  }>()
);
export const createRequestFailureAction = createAction(
  '[Requests] Create Request Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Edit Request
 */
export const editRequestAction = createAction(
  '[Requests] Edit Request Action',
  props<{
    request: EditRequest;
  }>()
);
export const editRequestSuccessAction = createAction(
  '[Requests] Edit Request Success Action',
  props<{
    requests: any;
  }>()
);
export const editRequestFailureAction = createAction(
  '[Requests] Edit Request Failure Action',
  props<{
    failure: Failure;
  }>()
);
/**
 * Actions For Export Requests
 */
export const exportRequestsAction = createAction(
  '[Requests] Export Requests Action',
  props<{
    request: Request[];
  }>()
);
export const exportRequestsSuccessAction = createAction(
  '[Requests] Export Requests Success Action',
  props<{
    response: any;
  }>()
);
export const exportRequestsFailureAction = createAction(
  '[Requests] Export Requests Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Requests
 */
export const getMyRequestsAction = createAction(
  '[Requests] Get My Requests Action',
  props<ApiQueryParams>()
  // props<{
  //   userId: string;
  // }>()
);
export const getMyRequestsSuccessAction = createAction(
  '[Requests] Get My Requests Success Action',
  props<{
    response: GetAllRequestResponse;
  }>()
);
export const getMyRequestsFailureAction = createAction(
  '[Requests] Get My Requests Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get Request By Id
 */
export const getRequestByIdAction = createAction(
  '[Requests] Get Request By Id Action',
  props<{
    requestId: string;
  }>()
);
export const getRequestByIdSuccessAction = createAction(
  '[Requests] Get Request By Id Success Action',
  props<{
    response: GetRequestToEditResponse;
  }>()
);
export const getRequestByIdFailureAction = createAction(
  '[Requests] Get Request By Id Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Requests Count
 */
export const getMyRequestsCountAction = createAction(
  '[Requests] Get My Requests Count  Action',
  props<{
    userId: string;
  }>()
);
export const getMyRequestsCountSuccessAction = createAction(
  '[Requests] Get My Requests Count  Success Action',
  props<{
    response: GetRequestsCountResponse;
  }>()
);
export const getMyRequestsCountFailureAction = createAction(
  '[Requests] Get My Requests Count Failure Action',
  props<{
    failure: Failure;
  }>()
);

/**
 * Actions For Get My Requests Count
 */
export const searchAction = createAction(
  '[Requests] Search  Action',
  props<{
    search: string;
  }>()
);
/**
 * Actions For Get My Requests Count
 */
export const paginatorAction = createAction(
  '[Requests] Paginator  Action',
  props<ApiQueryParams>()
);

export const RequestsActions = {
  /**
   * Actions For Get All Requests
   */
  getAllRequests: getAllRequestsAction,
  getAllRequestsSuccess: getAllRequestsSuccessAction,
  getAllRequestsFailure: getAllRequestsFailureAction,
  /**
   * Actions For Create Requests
   */
  createRequest: createRequestAction,
  createRequestSuccess: createRequestSuccessAction,
  createRequestFailure: createRequestFailureAction,
  /**
   * Actions For Edit Requests
   */
  editRequest: editRequestAction,
  editRequestSuccess: editRequestSuccessAction,
  editRequestFailure: editRequestFailureAction,

  /**
   * Actions For Export Requests
   */
  exportRequests: exportRequestsAction,
  exportRequestsSuccess: exportRequestsSuccessAction,
  exportRequestsFailure: exportRequestsFailureAction,

  /**
   * Actions For Get My Request
   */
  myRequests: getMyRequestsAction,
  myRequestsSuccess: getMyRequestsSuccessAction,
  myRequestsFailure: getMyRequestsFailureAction,

  /**
   * Actions For Get My Request
   */
  getRequestById: getRequestByIdAction,
  getRequestByIdSuccess: getRequestByIdSuccessAction,
  getRequestByIdFailure: getRequestByIdFailureAction,

  /**
   * Actions For Get My Requests Count
   */
  getMyRequestsCount: getMyRequestsCountAction,
  getMyRequestsCountSuccess: getMyRequestsCountSuccessAction,
  getMyRequestsCountFailure: getMyRequestsCountFailureAction,

  /**
   * Actions Search
   */
  search: searchAction,
};
